import { SignedIn, UserButton, SignedOut, SignUpButton } from "@clerk/remix";
import { NavLink } from "@remix-run/react";
import { Home } from "lucide-react";

export default function Header() {
  return (
    <header className="bg-black text-white shadow-sm dark:bg-black w-full fixed top-0 z-10 h-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full">
        <div className="flex justify-between items-center h-full">
          <div className="flex-shrink-0 flex items-center">
            <NavLink to="/" className="flex items-center justify-center">
              <img
                src="/cloud-check.png"
                alt="Cloud Exam Hub"
                className="h-6 w-6"
              />
              <span className="ml-2 font-bold text-xl">Cloud Exam Hub</span>
            </NavLink>
          </div>
          <div className="ml-6 flex items-center">
            <NavLink
              to="/user-home"
              className="text-gray-300 hover:text-gray-200 mr-4"
            >
              <Home className="h-6 w-6" />
            </NavLink>
            <SignedIn>
              <UserButton afterSignOutUrl="/" />
            </SignedIn>
            <SignedOut>
              <SignUpButton mode="modal">
                <button className="ml-4 px-3 py-2 rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700">
                  Sign Up
                </button>
              </SignUpButton>
            </SignedOut>
          </div>
        </div>
      </div>
    </header>
  );
}
